import React,{useContext} from 'react';
import { useEffect } from 'react';
import {GlobalLangCtx} from '../../App'
import './AboutMe.css'

const AboutMe = () =>
{
    const [selLan, setselLan] = useContext(GlobalLangCtx);
    const fLan = require (`../language_app/json_files/lang[${selLan}].json`)
    
    useEffect(() =>{
        // console.log(`change lan: ${selLan}`);
        // console.log(fLan);
    },[selLan])

    return (
        <section id='aboutBox' className='aboutMe_mainSec'>
            <h1 className='titleSec'>
                {fLan.aboutMe.title}
            </h1>
            <div className="descBlk">
                <p>
                    { fLan.aboutMe.desc0 }
                </p>
                <p>
                    { fLan.aboutMe.desc1 }
                </p>
                <p>
                    { fLan.aboutMe.desc2 }
                </p>
                <p>
                    { fLan.aboutMe.desc3 }
                </p>
                <p className='cl_lnk'>  {fLan.aboutMe.desc4} </p>
                <p className='cl_lnk' dangerouslySetInnerHTML={{__html: fLan.aboutMe.desc5 }}></p>
            </div>
        </section>
    )
}

export default AboutMe;